import { render, staticRenderFns } from "./PortfolioTabs.vue?vue&type=template&id=5bad2f08"
import script from "./PortfolioTabs.vue?vue&type=script&lang=ts"
export * from "./PortfolioTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports